import { useId, type SVGProps } from 'react';

/** Clip-path ids come from `useId`, so the same flag rendered twice (trigger and dropdown) doesn't collide. */
export function SpainFlag(props: SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 20 20" role="img" aria-hidden {...props}>
			<circle cx="10" cy="10" r="10" fill="#c60b1e" />
			<rect x="0" y="5.35" width="20" height="9.3" fill="#ffc400" />
		</svg>
	);
}

export function UkFlag(props: SVGProps<SVGSVGElement>) {
	const clip = useId();
	return (
		<svg viewBox="0 0 20 20" role="img" aria-hidden {...props}>
			<clipPath id={clip}>
				<circle cx="10" cy="10" r="10" />
			</clipPath>
			<g clipPath={`url(#${clip})`}>
				<rect width="20" height="20" fill="#012169" />
				<path d="M0 0l20 20M20 0L0 20" stroke="#fff" strokeWidth="3" />
				<path d="M10 0v20M0 10h20" stroke="#fff" strokeWidth="5" />
				<path d="M10 0v20M0 10h20" stroke="#c8102e" strokeWidth="3" />
			</g>
		</svg>
	);
}

export function CatalanFlag(props: SVGProps<SVGSVGElement>) {
	const clip = useId();
	return (
		<svg viewBox="0 0 20 20" role="img" aria-hidden {...props}>
			<clipPath id={clip}>
				<circle cx="10" cy="10" r="10" />
			</clipPath>
			<g clipPath={`url(#${clip})`}>
				<rect width="20" height="20" fill="#fcdd09" />
				{[2.9, 6.7, 10.5, 14.3, 18.1].map((y) => (
					<rect key={y} y={y} width="20" height="1.5" fill="#da121a" />
				))}
			</g>
		</svg>
	);
}

export function ItalyFlag(props: SVGProps<SVGSVGElement>) {
	const clip = useId();
	return (
		<svg viewBox="0 0 20 20" role="img" aria-hidden {...props}>
			<clipPath id={clip}>
				<circle cx="10" cy="10" r="10" />
			</clipPath>
			<g clipPath={`url(#${clip})`}>
				<rect width="6.67" height="20" fill="#009246" />
				<rect x="6.67" width="6.67" height="20" fill="#fff" />
				<rect x="13.33" width="6.67" height="20" fill="#ce2b37" />
			</g>
		</svg>
	);
}

export function FranceFlag(props: SVGProps<SVGSVGElement>) {
	const clip = useId();
	return (
		<svg viewBox="0 0 20 20" role="img" aria-hidden {...props}>
			<clipPath id={clip}>
				<circle cx="10" cy="10" r="10" />
			</clipPath>
			<g clipPath={`url(#${clip})`}>
				<rect width="6.67" height="20" fill="#002395" />
				<rect x="6.67" width="6.67" height="20" fill="#fff" />
				<rect x="13.33" width="6.67" height="20" fill="#ed2939" />
			</g>
		</svg>
	);
}
